//GenerateThink5whysCode.js
import React from 'react';

// Important: Ths GenerateThink5WhysCode also getting generated in GenerateThink5WhysCodeSignup.jsx
const GenerateThink5whysCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TU';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThink5whysTeamCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TT';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThink5whysProjectCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TO';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThink5whysProcessCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TB';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThink5whysLocationCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TN';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThink5whysLifeStageCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TE';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThink5whysFranchiseCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TF';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThink5whysChecklistCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TH';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};


const GenerateThinkleticsEventEnrollmentNumber = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'E01';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThinkleticsTeamCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TL';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateWorkshopEnrollmentNumber = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TW';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateRCACode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TR';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateLCCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TC';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GeneratePOVCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TP';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateApplauseCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TA';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateSugoCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TS';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateKaizenCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TK';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateIkigaiCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TI';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateMLMRequestCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TM';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateBookOrderNumber = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'BK';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateOFOrderNumber = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'OF';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateWalletTxnId = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'WL';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateOnlineTxnId = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'ON';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateThinkRentBookingNumber = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TR';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateRenewSubscription = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'RS';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GeneratePageTopupCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'PT';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};


const getYearCode = (year) => {
    const lastTwoDigits = year.toString().slice(-2);
    return lastTwoDigits;
};

const getMonthCode = (month) => {
    if (month >= 1 && month <= 9) {
        return month.toString();
    } else {
        return String.fromCharCode(64 + month - 9); // A = 10, B = 11, ...
    }
};

const getDayCode = (day) => {
    if (day >= 1 && day <= 9) {
        return day.toString();
    } else {
        return String.fromCharCode(64 + day - 9); // A = 10, B = 11, ...
    }
};

const getHourCode = (hour) => {
    if (hour >= 1 && hour <= 9) {
        return hour.toString();
    } else {
        return String.fromCharCode(64 + hour - 9); // A = 10, B = 11, ...
    }
};

const reverseThink5whysCode = (code) => {
    const prefix = code.slice(0, 2);  // 'TL'
    const year = code.slice(2, 4);    // Year part of the code
    const monthCode = code.slice(4, 6);   // Month part of the code
    const dayCode = code.slice(6, 8);     // Day part of the code
    const hourCode = code.slice(8, 10);   // Hour part of the code
    const minutes = code.slice(10, 12);   // Minute part of the code
    const seconds = code.slice(12, 14);   // Second part of the code
    const milliseconds = code.slice(14, 17); // Millisecond part of the code

    const yearDecoded = getYearFromCode(year);
    const monthDecoded = getMonthFromCode(monthCode);
    const dayDecoded = getDayFromCode(dayCode);
    const hourDecoded = getHourFromCode(hourCode);
    const dateString = `${prefix}${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    return dateString;
    
};

const GenerateAICounsellingOrderNumber = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'AI';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateResumeCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'RE';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateJDCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'JD';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateCoverLetterCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'CL';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateMarksTrackerCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'MT';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

// Helper functions to convert code back to numeric values
const getMonthFromCode = (code) => {
    if (code >= 'A' && code <= 'L') {
        return code.charCodeAt(0) - 64 + 9; 
    } else {
        return code;
    }
};

const getDayFromCode = (code) => {
    if (code >= 'A' && code <= 'Z') {
        return code.charCodeAt(0) - 64 + 9; 
    } else {
        return code;
    }
};

const getHourFromCode = (code) => {
    if (code >= 'A' && code <= 'Z') {
        return code.charCodeAt(0) - 64 + 9; 
    } else {
        return code;
    }
};

const GenerateSHGCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'SH';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateDigiBCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'DB';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateSCCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'SC';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateGLMCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'GLM';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateGLPCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'GLP';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateGLECode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'GLE';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateGLDCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'GLD';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GenerateGLXCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'GLX';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const Generate3PTaskCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = '3P';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const GeneratePassOrderNumber = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'PS';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};


export { 
    GenerateThink5whysCode, 
    GenerateThink5whysTeamCode, 
    GenerateThink5whysProjectCode, 
    GenerateThink5whysProcessCode,
    GenerateThink5whysLocationCode,
    GenerateThink5whysFranchiseCode, 
    GenerateThink5whysChecklistCode,
    GenerateThink5whysLifeStageCode,
    GenerateThinkleticsEventEnrollmentNumber,
    GenerateThinkleticsTeamCode,
    GenerateWorkshopEnrollmentNumber,
    GenerateRCACode,
    GenerateLCCode,
    GeneratePOVCode,
    GenerateApplauseCode,
    GenerateSugoCode,
    GenerateKaizenCode,
    GenerateIkigaiCode,
    GenerateMLMRequestCode,
    GenerateBookOrderNumber,
    GenerateOFOrderNumber,
    GenerateWalletTxnId,
    GenerateOnlineTxnId,
    GenerateThinkRentBookingNumber,
    GenerateRenewSubscription,
    GeneratePageTopupCode,
    reverseThink5whysCode,
    GenerateAICounsellingOrderNumber,
    GenerateResumeCode,
    GenerateJDCode,
    GenerateCoverLetterCode,
    GenerateMarksTrackerCode,
    GenerateSHGCode,
    GenerateDigiBCode,
    GenerateSCCode,
    GenerateGLMCode,
    GenerateGLPCode,
    GenerateGLECode,
    GenerateGLDCode,
    GenerateGLXCode,    
    Generate3PTaskCode,
    GeneratePassOrderNumber,
};